<!-- display-mobile-07 preview — a full-screen interstitial: creative behind, copy card in front -->
<app-mobile-frame>
  <!-- START: Interstitial -->
  <div class="da-interstitial">
    <img *ngIf="creativeImage" class="da-backdrop" [src]="creativeImage" alt="" aria-hidden="true" />

    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
      <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>
    </a>

    <span class="da-adchoices d-flex align-items-center justify-content-center">
      <i class="bi bi-info-circle"></i>
    </span>

    <div class="da-card">
      <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
      <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <div class="da-actions d-flex flex-row">
        <span class="da-close d-flex align-items-center justify-content-center">
          <span class="da-label">Close</span>
        </span>

        <a
          [href]="data.url" target="_blank" rel="noopener noreferrer"
          class="da-cta d-flex align-items-center justify-content-center"
        >
          <span class="da-label">{{ data.ctaText || "Your call to action" }}</span>
        </a>
      </div>
    </div>
  </div>
  <!-- END: Interstitial -->
</app-mobile-frame>
